import { defineStore } from 'pinia';
import { useLocalStorage } from '@vueuse/core';

export const useProductStore = defineStore('products', () => {
    const products = useLocalStorage('abodo/products', []);
});
